'use es6';

export const getJavascripts = state => state.javascripts;
export const getJavascriptsById = state => state.javascripts.byId;
export const getJavascriptsByPath = state => state.javascripts.byPath;
export const getJavascriptsOrderById = state => state.javascripts.orderById;